<template>
    <div
        class="tw-grid tw-grid-cols-12"
        :class="{
            'tw-bg-red-300 tw-rounded-md tw-p-2 tw-px-6': hasBackground,
            'tw-my-4': !hasNoYSpacing,
        }"
    >
        <div
            v-if="icon"
            class="tw-col-span-2 tw-pr-4 tw-content-center"
        >
            <component
                :is="icon"
                :class="{'tw-text-cyan-500': coloredIcon}"
            />
        </div>
        <div
            class="tw-content-center"
            :class="icon ? 'tw-col-span-10' : 'tw-col-span-12'"
        >
            <slot />
        </div>
    </div>
</template>

<script>
import CheckCircleIcon from "../icons/CheckCircleIcon.vue";
import ClockFaceIcon from "../icons/ClockFaceIcon.vue";
import HandshakeIcon from "../icons/HandshakeIcon.vue";
import LanguageIcon from "../icons/LanguageIcon.vue";
import MapIcon from "../icons/MapIcon.vue";
import ShoppingCartIcon from "../icons/ShoppingCartIcon.vue";
import CounterOneIcon from "../icons/CounterOneIcon.vue";
import CounterTwoIcon from "../icons/CounterTwoIcon.vue";
import CounterThreeIcon from "../icons/CounterThreeIcon.vue";
import GoogleIcon from "../icons/GoogleIcon.vue";
import PenIcon from "../icons/PenIcon.vue";
import ThumbsUpIcon from "../icons/ThumbsUpIcon.vue";
import SuccessIcon from "../icons/SuccessIcon.vue";
import RocketIcon from "../icons/RocketIcon.vue";
import TrophyIcon from "../icons/TrophyIcon.vue";

    export default {
        name: "InfoSnippet",
        components: {
            CheckCircleIcon,
            ClockFaceIcon,
            CounterOneIcon,
            CounterTwoIcon,
            CounterThreeIcon,
            HandshakeIcon,
            LanguageIcon,
            MapIcon,
            ShoppingCartIcon,
            GoogleIcon,
            PenIcon,
            ThumbsUpIcon,
            SuccessIcon,
            RocketIcon,
            TrophyIcon,
        },
        props: {
            icon: {
                type: String,
            },
            coloredIcon: Boolean,
            hasBackground: Boolean,
            hasNoYSpacing: Boolean,
        },
    }
</script>

<style scoped>
</style>